import React, { useState } from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
    ReferenceArea,
} from "recharts";
import { Modal, Typography, Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import OpenWithIcon from '@mui/icons-material/OpenWith';

export default function LineChartWeek({ data, title, idealValue }) {
    const [open, setOpen] = useState(false);

    const weeklyData = data?.slice(-7);
    const shouldShowExpand = data?.length > 7;

    return (
        <div style={{ width: "100%", height: "100%" }}>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignContent: 'space-between' }}>
                <Typography
                    variant="p"
                    align="left"
                    sx={{ marginLeft: 2, fontSize: "14px", fontWeight: "bold" }}
                >
                    {title
                        ?.toLowerCase()
                        .split("_")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")}
                </Typography>
                {shouldShowExpand && <OpenWithIcon onClick={() => setOpen(true)} sx={{ alignSelf: 'flex-end', right: 20, cursor: 'pointer', fontSize: 'medium' }} />}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'flex-end', }}>
                <Typography variant="p" align="right" fontSize={"9px"}>
                    Ideal - {idealValue}
                </Typography>
            </Box>
            <div style={{ width: "100%", height: "120px", marginTop: '15px', }}>
                <ResponsiveContainer>
                    <LineChart
                        data={weeklyData}
                        margin={{ top: 5, right: 5, left: 0, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        {/* <ReferenceArea
                            y1={6}
                            y2={8}
                            fill="rgba(153, 228, 249, 1)"
                            fillOpacity={0.15}
                        /> */}
                        <XAxis
                            dataKey="date"
                            fontSize={9}
                            interval="preserveStartEnd"
                            tick={{ dy: 6,fill: "#000", fontSize: '8px', fontWeight:'bold' }}
                            tickFormatter={(date) => {
                                const formattedDate = new Date(date);
                                return new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short' }).format(formattedDate);
                            }}
                        />
                        <YAxis fontSize={9} width={25}  tick={{fill: "#000", fontSize: '8px', fontWeight:'bold' }}/>
                        <Tooltip />
                        <Line
                            type="monotone"
                            dataKey="value"
                            stroke="rgba(24, 160, 251, 1)"
                            strokeWidth={2}
                            dot={{ r: 3 }}
                        />
                          {data?.length==0 && <text
                                x="50%"
                                y="50%"
                                textAnchor="middle"
                                fontSize={10}
                                fontWeight="bold"
                                fill="#888"
                                dy={5}
                            >
                                No data available
                            </text>}
                    </LineChart>
                </ResponsiveContainer>
            </div>

            {/* FULL SCREEN MODAL */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <div
                    style={{
                        background: "#fff",
                        padding: 20,
                        margin: "10vh auto",
                        width: "90%",
                        height: '45%',
                        maxWidth: 800,
                        borderRadius: 10,
                    }}
                >
                    <CloseIcon onClick={() => setOpen(false)} style={{ justifySelf: 'flex-end', display: 'flex', cursor: 'pointer' }} />
                    <div style={{ width: "98%", height: '98%', }}>
                        <ResponsiveContainer>
                            <LineChart data={data}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <ReferenceArea
                                    y1={9}
                                    y2={11}
                                    fill="rgba(153, 228, 249, 1)"
                                    fillOpacity={0.15}
                                />
                                <XAxis dataKey="date" fontSize={10}
                                    tickFormatter={(date) => {
                                        const formattedDate = new Date(date);
                                        return new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short' }).format(formattedDate);
                                    }}
                                />
                                <YAxis />
                                <Tooltip />
                                <Line type="monotone" dataKey="value" stroke="rgba(24, 160, 251, 1)" strokeWidth={2} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
